const key = (profileId, mediaId) => `mh_progress_${profileId}_${mediaId}`;

export const saveProgress = (profileId, mediaId, seconds, duration) => {
  if (!profileId || !mediaId || !duration || duration < 30) return;
  const pct = seconds / duration;
  // Clear progress when near the end (>92%) so the card resets
  if (pct > 0.92) {
    localStorage.removeItem(key(profileId, mediaId));
  } else {
    localStorage.setItem(key(profileId, mediaId), JSON.stringify({ seconds: Math.floor(seconds), duration: Math.floor(duration) }));
  }
};

export const getProgress = (profileId, mediaId) => {
  try {
    const raw = localStorage.getItem(key(profileId, mediaId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearProgress = (profileId, mediaId) => {
  localStorage.removeItem(key(profileId, mediaId));
};

// Returns a 0–100 percentage, or 0 if no progress
export const getProgressPct = (profileId, mediaId) => {
  const p = getProgress(profileId, mediaId);
  if (!p || !p.duration) return 0;
  const pct = (p.seconds / p.duration) * 100;
  return pct > 5 && pct < 92 ? pct : 0;
};
